import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5c-5.457 0 -10 3.028 -10 7s4.543 7 10 7s10 -3.028 10 -7s-4.543 -7 -10 -7z","key":"svg-0"}]]

/**
 * IconOvalVerticalFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItb3ZhbC12ZXJ0aWNhbCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgNWMtNS40NTcgMCAtMTAgMy4wMjggLTEwIDdzNC41NDMgNyAxMCA3czEwIC0zLjAyOCAxMCAtN3MtNC41NDMgLTcgLTEwIC03eiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/oval-vertical-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconOvalVerticalFilled = createReactComponent('filled', 'oval-vertical-filled', 'OvalVerticalFilled', __iconNode);

export default IconOvalVerticalFilled;